import clsx from 'clsx';
// assets
import styles from '@/modules/Chat/components/Message/Message.module.css';

interface MessageProps {
    className?: string;
    children: React.ReactNode;
}

const Message = ({ className, children }: MessageProps) => {
    return (
        <article className={clsx(styles.base, className)}>{children}</article>
    );
};

export default Message;
